import React from "react";
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";
import "react-datepicker/dist/react-datepicker.css";
import { Editor } from "@tinymce/tinymce-react";
import DatePicker from "react-date-picker";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { editPin, deletePins } from "../../actions/pins";
import ModalDeleteConfirm from "../Map/PinForms/ModalDeleteConfirm";
import PinHistory from "./PinHistory";
import { useRef, useState } from "react";
import { OpenStreetMapProvider } from "leaflet-geosearch";
import HelpOutlineSharpIcon from "@material-ui/icons/HelpOutlineSharp";
import AddressSearch from "../common/AddressSearch";

const TinyMCE_Key = process.env.REACT_APP_TINY_MCE_KEY;

// Strip TinyMCE's empty paragraph wrappers — returns "" when content is only whitespace/tags
const stripEmptyHtml = (html) => {
  if (!html) return '';
  const stripped = html.replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ').trim();
  return stripped === '' ? '' : html;
};

function EditStory(props) {
  const dispatch = useDispatch();
  const history = useHistory();
  const auth = useSelector((state) => state.auth);
  const { isAuthenticated, user } = auth;
  const [errorModal, setErrorModal] = useState(false);

  const toggleErrorModal = () => {
    setErrorModal(() => !errorModal);
  };

  const [deleteModal, setDeleteModal] = useState(false);
  const toggleDeleteModal = () => setDeleteModal(!deleteModal);
  const [historyModal, setHistoryModal] = useState(false);
  const toggleHistoryModal = () => setHistoryModal(!historyModal);

  const editorRef = useRef(null);

  const [addPinValues, setaddPinValues] = useState({
    // ...props.pinData,
    category: props.pinData.category,
    latitude: parseFloat(props.pinData.latitude),
    longitude: parseFloat(props.pinData.longitude),
    startDate: new Date(props.pinData.startDate),
    endDate: new Date(props.pinData.endDate),
    // anonradius: 1,
    address: props.pinData.address,
    locality: props.pinData.locality,
    region: props.pinData.region,
    country: props.pinData.country,
    postCode: props.pinData.postCode,
    title: props.pinData.title,
    description: props.pinData.description,
    lastEditDate: new Date(),
    lastPersonEdit: user ? user.id : null,
    owner: props.pinData.owner,
    is_anonymous_pin: props.pinData.is_anonymous_pin,
  });

  const isOwner = user && user.id === props.pinData.owner;
  const isCommunity = (props.pinData.categoryName && props.pinData.categoryName.toLowerCase() === 'community') || addPinValues.category === 4;

  const setCategory = (nextCategory) => {
    setaddPinValues({ ...addPinValues, category: nextCategory });
  };
  const handleAddressChange = (selectedOption) => {
    if (!isOwner && isCommunity) return; // non-owners can't change address
    setaddPinValues({
      ...addPinValues,
      address: selectedOption.value.raw.display_name,
      latitude: Number(selectedOption.value.y),
      longitude: Number(selectedOption.value.x),
    });

    props.centerMarker({
      latitude: selectedOption.value.y,
      longitude: selectedOption.value.x,
    });
  };

  const categoryOptions = [
    { value: 1, label: "personal", color: "#e01783" },
    { value: 2, label: "resources", color: "#00ce7d" },
    { value: 3, label: "historical", color: "#248dc1" },
    { value: 4, label: "community", color: "#4d3f87" },
  ];

  const setAnon = (nextAnon) => {
    setaddPinValues({ ...addPinValues, is_anonymous_pin: nextAnon });
  };

  const anonymousOptions = [
    { value: false, label: "no", color: "#e63f52" },
    { value: true, label: "yes", color: "#07cf81" },
  ];

  // for community non-owners we provide an append-only textarea `additionText`
  const [additionText, setAdditionText] = useState("");

  const submitEditPin = (e) => {
    e.preventDefault();
    // If user is not the owner and this is a community pin,
    // require an addition field and append it on the server.
    if (!isOwner && isCommunity) {
      if (!additionText || additionText.trim() === "") {
        setErrorModal(true);
        return;
      }
      const payload = {
        description_addition: additionText.trim(),
        lastPersonEdit: user ? user.id : null,
        lastEditDate: new Date(),
      };
      dispatch(editPin(payload, props.pinData.id));
      props.setEditStory(false);
      return;
    }

    const cleanedDescription = stripEmptyHtml(addPinValues.description);
    const valuesForSubmit = { ...addPinValues, description: cleanedDescription };
    if (
      valuesForSubmit.title && valuesForSubmit.description && valuesForSubmit.latitude &&
      valuesForSubmit.longitude && valuesForSubmit.address
    ) {
      dispatch(editPin(valuesForSubmit, props.pinData.id));
      props.setEditStory(false);

      history.replace({
        pathname: history.location.pathname,
        search: "",
        state: {},
      });
    } else {
      setErrorModal(true);
    }
  };

  const handleDelete = (e) => {
    e.preventDefault();

    // Delete the pin
    dispatch(deletePins(props.pinData.id));

    // Close modals
    toggleDeleteModal();

    // Close edit story modal if toggle exists
    if (props.toggle) {
      props.toggle();
    }

    // Close edit story by setting state
    if (props.setEditStory) {
      props.setEditStory(false);
    }

    // Redirect to home
    history.replace('/');
  };

  return (
    <div>
      <Form className="custom-form-text">
        <FormGroup>
          <Label className="custom-form-text" for="title">
            What's the name of this story?
          </Label>
          <Input
            className="form-control sidebar-input-placeholder"
            type="text"
            name="title"
            value={addPinValues.title}
            disabled={!isOwner && isCommunity}
            onChange={(e) =>
              setaddPinValues({
                ...addPinValues,
                title: e.target.value,
              })}
          />
        </FormGroup>
        <div className="mb-2">
          <Label className="custom-form-text" for="description">
            What happened in this story?
          </Label>
          {(!isOwner && isCommunity) ? (
            // non-owners add to the story via a simple textarea; existing content shown read-only below
            <>
              <textarea
                className="form-control"
                placeholder="Add to community pin"
                value={additionText}
                onChange={(e) => setAdditionText(e.target.value)}
                rows={6}
              />
              <div style={{ marginTop: 12, padding: 8, border: '1px solid #e0e0e0', borderRadius: 4 }}>
                <strong>Current story content</strong>
                <div style={{ marginTop: 8 }} dangerouslySetInnerHTML={{ __html: addPinValues.description || '' }} />
              </div>
            </>
          ) : (
            <Editor
              apiKey={TinyMCE_Key}
              onInit={(evt, editor) => editorRef.current = editor}
              content={addPinValues.description}
              onChange={(e) =>
                setaddPinValues({
                  ...addPinValues,
                  description: stripEmptyHtml(e.target.getContent()),
                })}
              init={{
                init_instance_callback: (editor) => {
                  editor.setContent(addPinValues.description);
                },
                height: 300,
                menubar: false,
                plugins: [
                  "advlist autolink lists link image charmap print preview anchor",
                  "searchreplace visualblocks code fullscreen",
                  "insertdatetime media table paste code help wordcount emoticons",
                ],
                toolbar: "undo redo | bold italic emoticons | link image | help ",
                content_style:
                  "body { font-family:Helvetica,Arial,sans-serif; font-size:14px } .img-responsive {  height: auto;  width: 100%; }",
                image_dimensions: false,
                image_class_list: [
                  { title: "img-responsive", value: "img-responsive" },
                ],
              }}
            />
          )}
        </div>
        <FormGroup>
          <Label className="custom-form-text" for="category">
            {" which category? "}
            <HelpOutlineSharpIcon style={{ alignSelf: "baseline" }} />
          </Label>
          <div id="category-selector" style={{ display: "inline-flex" }}>
            {categoryOptions.map((category) => {
              return (
                <span
                  key={category.label}
                  value={category.value}
                  style={addPinValues.category === category.value
                    ? { backgroundColor: category.color, color: "white" }
                    : { border: `1px solid ${category.color}` }}
                  className="custom-selector"
                  onClick={() => { if (isOwner || !isCommunity) setCategory(parseInt(category.value)) }}
                >
                  {category.label}
                </span>
              );
            })}
          </div>
        </FormGroup>
        <FormGroup>
          <Label className="custom-form-text">
            when did this story happen?
          </Label>
          <div style={{ display: "flex" }}>
            <div className="px-2" style={{ display: "block" }}>
              <Label className="custom-form-text pr-1" for="startDate">
                Start Date
              </Label>
              <DatePicker
                format={"MM/dd/yyyy"}
                name="startDate"
                minDate={new Date("0100-01-01")}
                maxDate={addPinValues.endDate}
                value={addPinValues.startDate}
                disabled={!isOwner && isCommunity}
                onChange={(date) =>
                  setaddPinValues({
                    ...addPinValues,
                    startDate: date,
                  })}
              />
            </div>
            <div style={{ display: "block" }}>
              <Label className="custom-form-text pr-1" for="endDate">
                End Date
              </Label>
              <DatePicker
                format={"MM/dd/yyyy"}
                minDate={addPinValues.startDate}
                name="endDate"
                value={addPinValues.endDate}
                disabled={!isOwner && isCommunity}
                onChange={(date) =>
                  setaddPinValues({
                    ...addPinValues,
                    endDate: date,
                  })}
              />
            </div>
          </div>
        </FormGroup>
        <AddressSearch
          setaddPinValues={setaddPinValues}
          addPinValues={addPinValues}
          // addressQuery={addressQuery}
          handleAddressChange={handleAddressChange}
        // validateAddress={validateAddress}
        // addressQueryLoading={addressQueryLoading}
        />
            <FormGroup>
              <Label className="custom-form-text" for="anonymous">
                {" make anonymous? "}
                <HelpOutlineSharpIcon />
              </Label>
              <div id="category-selector" style={{ display: "inline-flex" }}>
                {anonymousOptions.map((anon) => {
                  return (
                    <span
                      key={anon.label}
                      value={anon.value}
                      style={addPinValues.is_anonymous_pin === anon.value
                        ? { backgroundColor: anon.color, color: "white" }
                        : { border: `1px solid ${anon.color}` }}
                      className="custom-selector"
                      onClick={() => { if (isOwner || !isCommunity) setAnon(anon.value); }}
                    >
                      {anon.label}
                    </span>
                  );
                })}
              </div>
            </FormGroup>
        <div style={{ marginTop: "2rem" }} className="search-bar-btn-group">
          <Button
            type="button"
            className="search-bar-btn"
            onClick={() => {
              props.setEditStory(false);

              history.replace({
                pathname: history.location.pathname,
                search: "",      // <-- clears ?edit=...
                state: {},       // optional
              });
            }}
          >
            Cancel
          </Button>
          <Button
            type="button"
            disabled={!isAuthenticated}
            className="search-bar-btn"
            onClick={(e) => submitEditPin(e)}
          >
            save changes
          </Button>

          {isOwner && (
            <Button 
              type="button" 
              className="search-bar-btn"
              onClick={toggleDeleteModal}
            >
              delete story
            </Button>
          )}

          {(isOwner || (user && (user.is_administrator || user.is_moderator))) && (
            <Button
              type="button"
              className="search-bar-btn"
              onClick={() => toggleHistoryModal()}
            >
              view history
            </Button>
          )}

        </div>
      </Form>
      <Modal
        isOpen={errorModal}
        toggle={toggleErrorModal}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <ModalHeader>Oops, your post is missing someting</ModalHeader>
        <ModalBody>
          <ul>
            {addPinValues.address === ""
              ? (
                <>
                  <h5 className="mb-0 mt-2">Address</h5>doesn't have to be exact
                </>
              )
              : (null)}
            {addPinValues.title === ""
              ? (
                <>
                  <h5 className="mb-0 mt-2">Title</h5>what are you posting
                  about?
                </>
              )
              : (null)}
            {addPinValues.description === ""
              ? (
                <>
                  <h5 className="mb-0 mt-2">Description</h5>tell us a little
                  something
                </>
              )
              : (null)}
          </ul>
          <Button
            onClick={() => toggleErrorModal()}
            style={{ float: "right", marginLeft: "10px" }}
            className={"btn default-btn-purple"}
          >
            go back
          </Button>
        </ModalBody>

      </Modal>
      {/* Delete Confirmation Modal */}
      <ModalDeleteConfirm
        modalState={deleteModal}
        toggle={toggleDeleteModal}
        onSubmit={handleDelete}
      />
      <Modal isOpen={historyModal} toggle={toggleHistoryModal} size="lg">
        <div className="p-3">
          <h4>Pin Revision History</h4>
          <PinHistory pinId={props.pinData.id} onClose={toggleHistoryModal} onRevertClose={() => props.setEditStory && props.setEditStory(false)} />
        </div>
      </Modal>
    </div>
  );
}

export default EditStory;
